var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcBookmarkFilled = function SvgIcBookmarkFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.167 3.75c0-.46.373-.833.833-.833h10c.46 0 .834.373.834.833v12.64a.833.833 0 0 1-1.284.702l-4.099-2.635a.83.83 0 0 0-.901 0L5.45 17.092a.833.833 0 0 1-1.284-.701z"
  })));
};
export default SvgIcBookmarkFilled;